import {ActionTypes} from "./types";

const INITIAL_STATE = {
  membershipAccounts: undefined
};

const membershipAccountReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_MEMBERSHIPS_ACCOUNT_LIST:
      return {
        ...state,
        membershipAccounts: action.payload,
      };
    default:
      return state;
  }
};

export default membershipAccountReducer;